import { createFeatureSelector } from '@ngrx/store';

import { betslipFeatureKey } from '../base/store/state';
import { IBetslipDigitalState } from './state';

export const digitalStateSelector = createFeatureSelector<IBetslipDigitalState>(betslipFeatureKey);
